import { GeneralSelect } from '@clickcease/cc-client-components-lib'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { Products } from 'Types/Product'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SelectProductContainer, generalSelectStyle, SelectItem } from './SelectProducts.styled'
import { PRODUCTS_OPTIONS } from './helper'
import useAddDomainStore from '../../store/addDomainsStore'
import { useAllowedLimits } from 'Hooks/useAllowedLimits'
import { PRODUCTS_HIDE_SELECT_ALL } from '../../helpers'

export interface SelectProductsProps {
  onSelect: (selection: { paidMarketing?: boolean; botZapping?: boolean }) => void
  disabled?: boolean
  selected?: { paidMarketing?: boolean; botZapping?: boolean }
  disabledProducts?: Array<Products | undefined>
}
export const SelectProducts = ({
  onSelect,
  selected,
  disabled,
  disabledProducts,
}: SelectProductsProps) => {
  const { t } = useTranslation('domainManagement')
  const { productsLeft } = useAddDomainStore()
  const { data: packagesData } = useGetPackagingLimits()
  const { allowedProducts } = useAllowedLimits()

  const productsAllowed = useMemo(() => {
    if (!packagesData) return []
    return PRODUCTS_OPTIONS.filter((product) => packagesData[product.key]).map((product) => ({
      ...product,
      isDisabled: !productsLeft?.[product.value] && !selected?.[product.value],
      label: (
        <SelectItem>
          {product.label}{' '}
          <SelectItem leftPadding>
            {packagesData?.[product.limitKey] - productsLeft?.[product.value]}/
          </SelectItem>
          <SelectItem light>{packagesData?.[product.limitKey]}</SelectItem>
        </SelectItem>
      ),
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, packagesData, disabledProducts, productsLeft])

  const selectValue = (() => productsAllowed.filter((product) => !!selected?.[product.value]))()

  const handleSelect = (selected: typeof productsAllowed) => {
    onSelect(
      selected.reduce(
        (acc, product) => ({
          ...acc,
          [product.value]: product.isDisabled ? false : true,
        }),
        {}
      )
    )
  }

  // Check if More than one product is active
  const isSelectAll =
    Object.values(allowedProducts).reduce((count, prop) => count + (prop ? 1 : 0), 0) >
    PRODUCTS_HIDE_SELECT_ALL

  return (
    <SelectProductContainer>
      <GeneralSelect
        isMulti
        selectAll={isSelectAll}
        selectCss={generalSelectStyle(isSelectAll)}
        isDisabled={disabled}
        options={productsAllowed}
        value={selectValue}
        selectAllLabel={t('add_new_multiple_domains_modal.select_all')}
        onChange={(selected) => handleSelect([...selected])}
      />
    </SelectProductContainer>
  )
}
